<template>
  <div class="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gray-100">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <img class="mx-auto h-20 w-auto text-blue-500" src="../assets/app-logo-blue.svg" alt="Workflow" />
      <h2 class="text-center text-3xl font-extrabold text-midea-primary">
        Sign in to your account
      </h2>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white pt-8 pb-4 px-4 shadow sm:rounded-lg sm:px-10">

        <form class="space-y-6" @submit.prevent="submit" v-if="!forgotPassword">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">
              Email address
            </label>
            <div class="mt-1">
              <input id="email" name="email" type="email" v-model="email" autocomplete="email" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">
              Password
            </label>
            <div class="mt-1">
              <input id="password" name="password" type="password" v-model="password" autocomplete="current-password" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
            </div>
          </div>

          <p v-if="error" class="mt-2 text-sm text-red-600" id="email-error">{{error}}</p>

          <!-- <div class="flex items-center justify-between">
            <div class="text-sm">
              <a @click.prevent="forgotPassword = true" class="font-medium text-blue-600 hover:text-blue-500 cursor-pointer">
                Forgot your password?
              </a>
            </div>
          </div> -->

          <div>


            <button type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-midea-primary hover:bg-midea-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
              Sign in
            </button>
          </div>

          <p class="text-xs italic -mt-4 w-full text-center" >
            Touble logging in? Please contact warranty@mideauk.co.uk
          </p>
        </form>

        <form class="space-y-6" @submit.prevent="submitForgotPassword" v-if="forgotPassword && !forgotPasswordSubmitted">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">
              Email address
            </label>
            <div class="mt-1">
              <input id="email" name="email" type="email" v-model="email" autocomplete="email" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
            </div>
          </div>

          <div class="text-red-500 text-sm" v-if="forgotPasswordError">{{forgotPasswordError}}</div>

          <button type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
              Send reset link
          </button>
        </form>

        <div v-if="forgotPassword && forgotPasswordSubmitted" class="flex flex-col gap-4 text-sm text-gray-700">
          <CheckCircleIcon class="w-16 h-16 mx-auto text-green-400"></CheckCircleIcon>
          <div>Your password reset request has been submitted successfully.</div>
          <div>If you have an account associated to this email address, you will receive an email to reset your password.</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import { CheckCircleIcon } from '@heroicons/vue/outline';


export default {
  components: {
    CheckCircleIcon
  },
  data: function() {
    return {
      email: '',
      password: '',
      error: null,
      
      forgotPassword: false,
      forgotPasswordSubmitted: false,
      forgotPasswordError: ''
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions(['login']),
    submit: async function() {
      this.error = null
      this.error = await this.login({
        email: this.email, 
        password: this.password
      });

      if (!this.error) {
          this.$router.push('/')
      }
    },
    submitForgotPassword: async function() {
      try {
        let url = document.location.origin
        if (document.location.href.indexOf('/#/') != -1) url += '/#'
        
        this.forgotPasswordError = ''
        await this.axios.post('/forgotpassword', { email: this.email, url })
        this.forgotPasswordSubmitted = true
      }
      catch {
        this.forgotPasswordError = 'Error submitting request'
      }
    }
  }
}
</script>